// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminSearchController from "./admin_search_controller"
application.register("admin-search", AdminSearchController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import AdminUpsellFlagsController from "./admin_upsell_flags_controller"
application.register("admin-upsell-flags", AdminUpsellFlagsController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import BadgeVariantController from "./badge_variant_controller"
application.register("badge-variant", BadgeVariantController)

import ClaimantRoleController from "./claimant_role_controller"
application.register("claimant-role", ClaimantRoleController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CompanySearchController from "./company_search_controller"
application.register("company-search", CompanySearchController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import GuidedSearchController from "./guided_search_controller"
application.register("guided-search", GuidedSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LeadModalController from "./lead_modal_controller"
application.register("lead-modal", LeadModalController)

import LicenseCheckController from "./license_check_controller"
application.register("license-check", LicenseCheckController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import QuizWidgetController from "./quiz_widget_controller"
application.register("quiz-widget", QuizWidgetController)

import ReportRouterController from "./report_router_controller"
application.register("report-router", ReportRouterController)

import SearchLoadingController from "./search_loading_controller"
application.register("search-loading", SearchLoadingController)

import SalesCallSearchController from "./sales_call_search_controller"
application.register("sales-call-search", SalesCallSearchController)

import OutreachCallController from "./outreach_call_controller"
application.register("outreach-call", OutreachCallController)

import SopSectionController from "./sop_section_controller"
application.register("sop-section", SopSectionController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import VerificationCodeController from "./verification_code_controller"
application.register("verification-code", VerificationCodeController)
